import MatchHeight from 'vanilla-js-match-height';

export default function Heights() {
	// Create new instances of MatchHeight for different elements
	// Each instance will ensure that elements with the same class have the same height

	new MatchHeight('.js-product-name'); // Match heights of elements with the class 'js-product-name'
	new MatchHeight('.js-product-price'); // Match heights of elements with the class 'js-product-price'
	new MatchHeight('.js-product-card'); // Match heights of elements with the class 'js-product-card'
	new MatchHeight('.js-post-heading'); // Match heights of elements with the class 'js-post-heading'
	new MatchHeight('.js-banner-heading'); // Match heights of elements with the class 'js-banner-heading'
	new MatchHeight('.js-banner-content'); // Match heights of elements with the class 'js-banner-content'
	new MatchHeight('.js-card-title'); // Match heights of elements with the class 'js-card-title'
	new MatchHeight('.js-card-content'); // Match heights of elements with the class 'js-card-content'

	new MatchHeight('.js-product-feed-title'); // Match heights of elements with the class 'js-product-feed-title'
	new MatchHeight('.js-product-feed-description'); // Match heights of elements with the class 'js-product-feed-description'
	new MatchHeight('.js-process-title'); // Match heights of elements with the class 'js-process-title'
	new MatchHeight('.js-process-content'); // Match heights of elements with the class 'js-process-content'

	new MatchHeight('.js-search-title'); // Match heights of elements with the class 'js-search-title'
	new MatchHeight('.js-post-title'); // Match heights of elements with the class 'js-post-title'
	new MatchHeight('.js-service-heading'); // Match heights of elements with the class 'js-service-heading'
	new MatchHeight('.js-accordion-title'); // Match heights of elements with the class 'js-accordion-title'

	new MatchHeight('.js-testimonial-content'); // Match heights of elements with the class 'js-testimonial-content'
	new MatchHeight('.js-testimonial-name'); // Match heights of elements with the class 'js-testimonial-content'

	new MatchHeight('.js-faq-question'); // Match heights of elements with the class 'js-faq-question'
	new MatchHeight('.js-faq-answer'); // Match heights of elements with the class 'js-faq-answer'

	let windowWidth = window.innerWidth;

	if (windowWidth > 1279) {
		heights();
	}

	window.addEventListener('resize', function () {
		windowWidth = window.innerWidth;

		if (windowWidth > 1279) {
			heights();
		}
	});

	function heights() {
		new MatchHeight('.js-product-feed-height', {
			byRow: true
		}); // Match heights of elements with the class 'js-product-feed-height'
		new MatchHeight('.js-testimonial-height', {
			byRow: true
		}); // Match heights of elements with the class 'js-testimonial-height'
	}


}
